import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  LinearProgress,
} from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import TokenPool from "../SearchTokenPools/TokenPool";
import ProjectDetailsModal from "../Modals/ProjectDetailsModal";
import { getTableData } from "../../redux/actions/web3Actions";
// import TokenPool from "../components/SearchTokenPools/TokenPool";
// import ProjectDetailsModal from "../components/Modals/ProjectDetailsModal";
import { useDispatch, useSelector } from "react-redux";
import { useWeb3React } from "@web3-react/core";
const useStyles = makeStyles((theme) => ({
  table: {
    border: "1px solid pink",
    // height: "10rem",
    marginTop: "1rem",
    // height:"auto"
  },
  Card3: {
    width: "100%",
    backgroundColor: "white",
    padding: "2.5rem",
    borderRadius: "8px",

    boxShadow: "4px 4px 30px rgba(34, 43, 69, 0.08)",

    // height: "30rem",
    marginTop: "3rem",
  },
  pageHeading: {
    fontWeight: "700",
    fontSize: "2rem",
    lineHeight: "3rem",
    // marginBottom: "4rem",
    marginLeft: "1rem",
  },
  head: {
    height: "4rem",
    backgroundColor: "rgba(246, 48, 169, 0.1)",
    display: "flex",
    // justifyContent: "space-around",
    alignItems: "center",
    textAlign: "center",
  },
  body: {
    display: "flex",
    flexDirection: "column",

    textAlign: "center",
  },
  headingText: {
    fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyText: {
    // fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  dot: {
    backgroundColor: ({ color }) => color,
    height: "5px",
    width: "5px",
    borderRadius: "100%",
    margin: "0px 5px 0px 0px",
  },

  row: {
    display: "flex",
    height: "4rem",
    alignContent: "center",
    margin: "3px 0px",
    // backgroundColor: "aqua",
  },
  statusText: {
    borderRadius: "12px",
    backgroundColor: ({ bgcolor }) => bgcolor,

    padding: "3px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonBox: {
    fontWeight: "600",
    flex: "1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  button: {
    borderRadius: "4px",
    border: "1px solid #f630A9",
    padding: "0.6rem 1.5rem",
    color: "#f630A9",
    fontWeight: "700",
  },
}));

const Dot = (color) => {
  // console.log("color", color);
  const classes = useStyles(color);

  return <Box className={classes.dot}></Box>;
};
const StatusBox = ({ d, bgcolor }) => {
  // console.log("dddddddd", bgcolor, d);
  const classes = useStyles({ bgcolor });
  return (
    <Box className={classes.statusText}>
      <Dot color={d?.status == "Complete" ? "#1ED059" : "#0843F5"} />
      <Typography>{d?.status}</Typography>
    </Box>
  );
};

const SearchTokenPools = ({
  title,
  Theading,
  withdrawData,
  depositData,
  selectedTableData,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [data2, setData2] = useState();

  const [depoData, setDepoData] = useState([]);
  const [vestingDataArray, setVestingDataArray] = useState([]);

  const [vestingDepositDataArray, setVestingDepositDataArray] = useState([]);
  const [depositDataArray, setDepositDataArray] = useState([]);

  const [vestingValue, setVestingValue] = useState("0");
  const [vestingDepositValue, setVestingDepsoitValue] = useState("0");

  const [count, setCount] = useState(0);

  const isUser = useSelector((state) => state.ui.isUser);

  useEffect(() => {
    dispatch(getTableData(isUser?.kol?._id));
  }, [isUser]);
  console.log({ selectedTableData });

  const VestingRowsData = () => {
    console.log(
      "CALLED-------------------------------",
      selectedTableData[0]?.projectId?.tokenNomicId?.vesting?.value
    );
    if (vestingValue) {
      console.log("CHALA");

      return vestingDataArray.map((item) => (
        <Box className={classes.row}>
          <Typography className={classes.bodyText}>{item.pname}</Typography>
          <Typography className={classes.bodyText}>
            {item.tokenAmount}
          </Typography>

          <Box className={classes.bodyText}>
            <StatusBox
              d={item}
              bgcolor={item.status == "Complete" ? "#B2F2C6" : "#ECF1FF"}
            />
          </Box>

          <Box className={classes.buttonBox}>
            <Typography className={classes.button}>{item.button}</Typography>
          </Box>
        </Box>
      ));
      // }
      return <></>;
    }
    return <></>;
  };

  const VestingDepositRowsData = () => {
    // console.log(
    //   "CALLED-------------------------------",
    //   selectedTableData[0]?.projectId?.tokenNomicId?.vesting?.value
    // );
    if (vestingDepositValue) {
      console.log("vestingDepositDataArray", vestingDepositDataArray);

      return vestingDepositDataArray.map((item) => (
        <Box className={classes.row}>
          <Typography className={classes.bodyText}>{item.pname}</Typography>
          <Typography className={classes.bodyText}>
            {item.tokenAmount}
          </Typography>

          <Box className={classes.bodyText}>
            <StatusBox
              d={item}
              bgcolor={item.status == "Complete" ? "#B2F2C6" : "#ECF1FF"}
            />
          </Box>

          <Box className={classes.buttonBox}>
            <Typography className={classes.button}>{item.button}</Typography>
          </Box>
        </Box>
      ));
      // }
      return <></>;
    }
    return <></>;
  };

  useEffect(() => {
    if (
      selectedTableData?.length > 0 &&
      selectedTableData[0]?.projectId?.tokenNomicId?.vesting?.value
    ) {
      setVestingValue(
        selectedTableData[0]?.projectId?.tokenNomicId?.vesting?.value
      );
    }
  }, [selectedTableData]);

  useEffect(() => {
    console.log({ depositDataArray });
    if (depositDataArray[0]?.tokenNomicId?.vesting?.value) {
      setVestingDepsoitValue(depositDataArray[0]?.tokenNomicId?.vesting?.value);
    }
    console.log({ vestingDepositValue });
  }, [depositDataArray[0]?.tokenNomicId?.vesting?.value]);

  useEffect(() => {
    if (vestingValue) {
      setVestingDataArray(() =>
        Array(parseInt(vestingValue))
          .fill(selectedTableData && selectedTableData[0])
          .map((d) => {
            return {
              pname: d.projectId?.tokenNomicId?.vesting?.duration,
              tokenAmount:
                d.campaignId.budget *
                ((100 - d.projectId.tokenNomicId.tgeRelease) /
                  (vestingValue * 100)),
              status: d.status,
              button: "Claim",
            };
          })
      );
    }
  }, [vestingValue]);

  useEffect(() => {
    if (vestingDepositValue) {
      console.log("dikhao  ===> ", depositDataArray[0], vestingDepositValue);

      setVestingDepositDataArray(() =>
        Array(parseInt(vestingDepositValue))
          .fill(depositDataArray[0])
          .map((d) => {
            return {
              pname: d?.tokenNomicId?.vesting?.duration,
              tokenAmount:
                d?.campaigns[0]?.budget *
                ((100 - d?.tokenNomicId?.tgeRelease) /
                  (vestingDepositValue * 100)),
              status: "Pending",
              button: "Deposit",
            };
          })
      );
    }
  }, [vestingDepositValue]);

  const tableData = useSelector((state) => state.ui.tableData);

  console.log("ALL DATA redux ===> ", withdrawData, depositData);
  // const heading = ["Vesting Release", "Deposit token ", "Deposit Status", " "];
  useEffect(() => {
    // ---------------------------for Kol table
    if (tableData) {
      setData(
        tableData?.map((t) => {
          return {
            pname: "TGE",
            tokenAmount: t.tokenAmount,
            status: t.status,
            button: "Claim",
          };
        })
      );
    }
    if (
      selectedTableData?.length > 0 &&
      selectedTableData[0]?.projectId?.tokenNomicId?.vesting?.duration
    ) {
      setData2({
        pname: "TGE",
        tokenAmount:
          selectedTableData[0].campaignId.budget *
          (selectedTableData[0].projectId.tokenNomicId.tgeRelease / 100),
        status: selectedTableData[0].status,
        button: "Claim",
      });
    }
    // console.log("WITHDRAW DATA FROM PROPS", withdrawData[0]);
    // ---------------------------Both for Project table
    if (withdrawData?.length >= 0) {
      setData(
        withdrawData?.map((t) => {
          return {
            pname: t.kolId?.name,
            tokenAmount: t.invested,
            status: t.status,
            button: "Withdraw",
          };
        })
      );
    }

    if (depositData) {
      let depDataArray = [{ ...depositData }];
      setDepositDataArray(depDataArray);
      console.log("depositDataArray ===> ", depositDataArray);

      setData(
        depDataArray?.map((t) => {
          return {
            pname: "TGE",
            tokenAmount:
              t?.campaigns[0]?.budget * (t?.tokenNomicId?.tgeRelease / 100),
            status: "Pending",
            button: "Depsoit",
          };
        })
      );
    }
    console.log("oi===> ", data);
  }, [tableData, withdrawData, depositData, isUser, selectedTableData]);

  console.log("sarah", selectedTableData);

  return (
    <Box className={classes.Card3}>
      <Typography className={classes.pageHeading}>{title}</Typography>
      <Box className={classes.table}>
        <Box className={classes.head}>
          {Theading?.map((h) => {
            return <Typography className={classes.headingText}>{h}</Typography>;
          })}
        </Box>

        <Box className={classes.body}>
          {selectedTableData?.length > 0 && selectedTableData[0]?.projectId ? (
            <>
              <Box className={classes.row}>
                <Typography className={classes.bodyText}>
                  {data2?.pname}
                </Typography>
                <Typography className={classes.bodyText}>
                  {data2?.tokenAmount}
                </Typography>

                <Box className={classes.bodyText}>
                  <StatusBox
                    d={data2}
                    bgcolor={
                      data2?.status == "Complete" ? "#B2F2C6" : "#ECF1FF"
                    }
                  />
                </Box>

                <Box className={classes.buttonBox}>
                  <Typography className={classes.button}>
                    {data2?.button}
                  </Typography>
                </Box>
              </Box>
              {vestingValue && <VestingRowsData />}
            </>
          ) : (
            data?.map((d) => {
              return (
                <>
                  <Box className={classes.row}>
                    <Typography className={classes.bodyText}>
                      {d.pname}
                    </Typography>
                    <Typography className={classes.bodyText}>
                      {d.tokenAmount}
                    </Typography>

                    <Box className={classes.bodyText}>
                      <StatusBox
                        d={d}
                        bgcolor={d.status == "Complete" ? "#B2F2C6" : "#ECF1FF"}
                      />
                    </Box>

                    <Box className={classes.buttonBox}>
                      <Typography className={classes.button}>
                        {d.button}
                      </Typography>
                    </Box>
                  </Box>
                  {vestingDepositValue && <VestingDepositRowsData />}
                </>
              );
            })
          )}
          {/* {depoData?.map((d) => {
            return (
              <Box className={classes.row}>
                <Typography className={classes.bodyText}>{d.pname}</Typography>
                <Typography className={classes.bodyText}>
                  {d.tokenAmount}
                </Typography>

                <Box className={classes.bodyText}>
                  <StatusBox
                    d={d}
                    bgcolor={d.status == "Complete" ? "#B2F2C6" : "#ECF1FF"}
                  />
                </Box>

                <Box className={classes.buttonBox}>
                  <Typography className={classes.button}>{d.button}</Typography>
                </Box>
              </Box>
            );
          })} */}
        </Box>
      </Box>
    </Box>
  );
};

export default SearchTokenPools;
